import { createSlice } from "@reduxjs/toolkit";
import { IDashboardState } from "./types";
import { getDashboardData } from "./thunks";

const initialState: IDashboardState = {
  inProgress: false,
  error: "",
  dashboradData: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state, action) => {
      state.inProgress = true;
      state.error = null;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.inProgress = false;
      state.dashboradData = action.payload;
    });
    builder.addCase(getDashboardData.rejected, (state, action) => {
      state.inProgress = false;
      state.error = action.payload;
    });
  },
});

export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
